import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = { class: "space-y-1" }
const _hoisted_4 = { class: "mt-2 border-t border-catering-cream-300 pt-2" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-[11px] text-catering-ink-500"
}

import { h } from 'vue'

export default {
  __name: 'BotOrderTotalBreakdown',
  props: { block: { type: Object, required: true } },
  setup(__props) {


const Row = props =>
  h('div', { class: 'flex items-baseline justify-between gap-3' }, [
    h('dt', { class: props.strong ? 'font-semibold text-catering-ink-900' : 'text-catering-ink-600' }, props.label),
    h(
      'dd',
      {
        class: [
          'tabular-nums',
          props.accent
            ? 'font-semibold text-catering-herb-600'
            : props.strong
              ? 'font-semibold text-catering-ink-900'
              : 'text-catering-ink-700'
        ]
      },
      props.value
    )
  ])

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "Order " + _toDisplayString(__props.block.order), 1),
    _createElementVNode("dl", _hoisted_3, [
      _createVNode(Row, {
        label: "Line items",
        value: __props.block.line_items_subtotal
      }, null, 8, ["value"]),
      (__props.block.fulfillment && __props.block.fulfillment !== '$0.00')
        ? (_openBlock(), _createBlock(Row, {
            key: 0,
            label: "Fulfillment",
            value: __props.block.fulfillment
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (__props.block.fulfillment_off && __props.block.fulfillment_off !== '$0.00')
        ? (_openBlock(), _createBlock(Row, {
            key: 1,
            label: "Free shipping",
            value: '-' + __props.block.fulfillment_off
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (__props.block.discounts && __props.block.discounts !== '$0.00')
        ? (_openBlock(), _createBlock(Row, {
            key: 2,
            label: "Discounts",
            value: '-' + __props.block.discounts
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createVNode(Row, {
        label: "Subtotal",
        value: __props.block.subtotal,
        strong: ""
      }, null, 8, ["value"]),
      (__props.block.tax && __props.block.tax !== '$0.00')
        ? (_openBlock(), _createBlock(Row, {
            key: 3,
            label: "Tax",
            value: __props.block.tax
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.fees_charged_to_customer || [], (f, i) => {
        return (_openBlock(), _createBlock(Row, {
          key: i,
          label: f.label,
          value: f.amount
        }, null, 8, ["label", "value"]))
      }), 128)),
      (__props.block.tip && __props.block.tip !== '$0.00')
        ? (_openBlock(), _createBlock(Row, {
            key: 4,
            label: "Tip",
            value: __props.block.tip
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createVNode(Row, {
        label: "Order total",
        value: __props.block.grand_total,
        strong: ""
      }, null, 8, ["value"]),
      (__props.block.credits && __props.block.credits !== '$0.00')
        ? (_openBlock(), _createBlock(Row, {
            key: 5,
            label: "Credits / gift card",
            value: '-' + __props.block.credits
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Row, {
        label: "Customer paid",
        value: __props.block.chargeable,
        strong: ""
      }, null, 8, ["value"]),
      _createVNode(Row, {
        label: "Bottle's cut",
        value: '-' + __props.block.bottle_cut
      }, null, 8, ["value"]),
      _createVNode(Row, {
        label: "Your payout",
        value: __props.block.net_payout,
        strong: "",
        accent: ""
      }, null, 8, ["value"])
    ]),
    (__props.block.bottle_cut_note)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.block.bottle_cut_note), 1))
      : _createCommentVNode("", true)
  ]))
}
}

}